import LazyLoad from "vanilla-lazyload";
import 'slick-carousel'
import $ from "jquery";

export default () => {

  const carouselGallery = document.querySelectorAll('[data-slick]')

  carouselGallery.forEach((gallery) => {
    let additionalOptions = gallery.getAttribute('data-options')
    try {
      additionalOptions = JSON.parse(additionalOptions)
    } catch (error) {
      additionalOptions = {}
    }

    const prevArrows = gallery.querySelectorAll('.nav-prev')
    const nextArrows = gallery.querySelectorAll('.nav-next')

    $(gallery).slick({
      ...additionalOptions
    })

    prevArrows.forEach((e) => {
      if (e) {
        e.addEventListener('click', () => {
          window.jQuery(gallery).slick('slickPrev')
        })
      }
    })
    nextArrows.forEach((e) => {
      if (e) {
        e.addEventListener('click', () => {
          window.jQuery(gallery).slick('slickNext')
        })
      }
    })
  })


  new LazyLoad({
    callback_error: (e) => {
      e.src = e.getAttribute('data-src')
    }
  });

  setTimeout(() => {
    document.querySelectorAll("[data-mf-video]").forEach(el => {
      const hasAutoplay = el.getAttribute("autoplay")
      if(hasAutoplay === null) {
      } else {
        el.play()
      }

     // el.setAttribute("data-video-plyr",1)
    })
  },1000)


}
